module.exports = __webpack_public_path__ + "static/media/icons.962a1bf3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styling/theme/assets/fonts/icons.svg
// module id = ./src/styling/theme/assets/fonts/icons.svg
// module chunks = 0